module.exports = __webpack_public_path__ + "static/media/cmng_events_header_img.43954d5f.jpg";